"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var redux_observable_1 = require("redux-observable");
var eventSummary_1 = require("../actions/internal/eventSummary");
var rxjs_1 = require("rxjs");
var types_1 = require("../actions/internal/types");
var operators_1 = require("rxjs/operators");
var util_1 = require("./util");
var params_1 = require("./util/params");
function buildEventSummaryQueryString(action) {
    var _a = action.args, eventId = _a.eventId, searchTerm = _a.searchTerm, fro = _a.fro, limit = _a.limit;
    return "event/" + eventId + "/searchSummary" +
        params_1.formatParams([
            { searchTerm: searchTerm },
            { fro: fro, param: 'from' },
            { limit: limit }
        ]);
}
exports.buildEventSummaryQueryString = buildEventSummaryQueryString;
// results/event/{eventId}/searchSummary
function getEventSummaryEpic(actions$) {
    return actions$.pipe(redux_observable_1.ofType(types_1.InternalClientActionType.GET_EVENT_SUMMARY), operators_1.flatMap(function (action$) {
        var args = action$.args;
        return rxjs_1.from(util_1.waitForData(args, buildEventSummaryQueryString(action$), eventSummary_1.getEventSummaryCompleteInternal, eventSummary_1.getEventSummaryErrorInternal)).pipe(operators_1.catchError(function (err) { return rxjs_1.of(err); }));
    }), operators_1.catchError(function (err) { return rxjs_1.of(err); }));
}
exports.getEventSummaryEpic = getEventSummaryEpic;
//# sourceMappingURL=eventSummaryEpic.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/epics/eventSummaryEpic.js
 ** module id = 2074
 ** module chunks = 0
 **/